/** @jsxImportSource @emotion/react */

import { Global, css } from '@emotion/react'
import { CssBaseline, Link, Pagination } from '@mui/material'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import { ChangeEvent, Fragment, ReactElement } from 'react'
import { FeaturedArticle, PaginationType } from '../types'
import routes from '../utils/routes'

type Props = {
  articles: ReadonlyArray<FeaturedArticle>
  pagination: PaginationType
  is_food?: boolean
}

export default function Index({ articles, pagination, is_food = false }: Props): ReactElement {
  const handlePaginationChange = (e: ChangeEvent, page: number) => {
    const query = new URLSearchParams(window.location.search)
    const article_type = query.get('article_type')
    location.href = routes.featured_articles_path({ page, article_type })
  }

  return (
    <Fragment>
      <CssBaseline />
      <Global
        styles={css`
          .articles_wrapper {
            padding: constant(safe-area-inset-top) constant(safe-area-inset-right)
              constant(safe-area-inset-left);
            padding: env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-left);
            width: 100%;
          }

          @media screen and (min-width: 1050px) {
            .articles_wrapper {
              max-width: 480px;
            }
          }
        `}
      />
      <div css={articlesWrapperStyle} className="articles_wrapper">
        {is_food && (<h2 style={{ marginLeft: '2.5%' }}>おすすめのレシピ特集</h2>)}
        <div css={articlesStyle}>
          {articles.map((article) => (
            <Link
              key={article.id}
              href={routes.featured_article_path(article.id)}
              css={articleBannerLink}
              className="article_link"
            >
              <img css={articleBannerImage} src={article.appTopBanner?.url} />
            </Link>
          ))}
        </div>
        <ThemeProvider theme={theme}>
          <Pagination
            count={pagination.totalPages}
            defaultPage={pagination.currentPage}
            onChange={handlePaginationChange}
            css={articlePagination}
            color="primary"
          />
        </ThemeProvider>
      </div>
    </Fragment>
  )
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#f70816',
    },
  },
})

const articlesWrapperStyle = css`
  overflow-x: hidden;
  margin: 24px auto 48px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`

const articlesStyle = css`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  ::after {
    content: '';
    display: block;
    width: 45%;
  }
`

const articleBannerLink = css`
  width: 45%;
  overflow: hidden;
  margin-bottom: 24px;
  display: flex;
`

const articleBannerImage = css`
  width: 100%;
  border: 0.5px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
`

const articlePagination = css`
  width: 100%;
  display: flex;
  justify-content: center;
`
